export const selectOverheadCranesData = (state) => state.overheadCrane?.data || [];
export const selectOverheadCranesLoading = (state) => state.overheadCrane?.loading || false;
export const selectOverheadCranesError = (state) => state.overheadCrane?.error || null;
export const selectSelectedOverheadCrane = (state) => state.overheadCrane?.selectedOverheadCrane || null;
export const selectOverheadCraneMaintenanceRecordsData = (state) => state.overheadCrane?.maintenanceRecords || [];
export const selectMaintenanceRecordData = (state) => state.overheadCrane?.selectedMaintenanceRecord || null;
export const selectOverheadCraneMaintenanceData = (state) => state.overheadCrane?.maintenanceData || null;
export const selectCellHistoryData = (state) => state.overheadCrane?.cellHistoryData || [];

